import React from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import PlacementAdminPage from "../placement/PlacementAdminPage";

export default function PlacementLandingPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <AdminNavbar />
      <PlacementAdminPage />
    </div>
  );
}
